wbApp.controller('CompensationsCoursesCtrl', ['$scope', 'compensationsSvc',
function ($scope, compensationsSvc) {


    $scope.compensationCoursesGridFilterOptions = {
        filterText: ""
    };

    $scope.compensationCoursesGridOptions = {
        sortInfo: { fields: ['courseFullName'], directions: ['dsc'] },
        columnDefs: [
            { field: 'courseFullName', displayName: "TXT_LAB_COURSE", sort: 'locale' },
            { field: 'eligiblePreAmends', displayName: "TXT_LBL_PRE_AMENDS_GRANTED", width: '90px', align: 'right' },
            { field: 'remainingPreAmends', displayName: "TXT_LBL_PRE_AMENDS_LEFT", width: '90px', align: 'right' },
            { field: 'preAmendsTaken', displayName: "TXT_LBL_PRE_AMENDS_TAKEN", width: '90px', align: 'right' },
            { field: 'eligibleAmends', displayName: "TXT_LBL_ELIGIBLE_AMENDS", width: '90px', align: 'right' },
            { field: 'remainingAmends', displayName: "TXT_LBL_AMENDS_LEFT", width: '90px', align: 'right' },
            { field: 'eligibleTimeBoundAmends', displayName: "TXT_LBL_ELIGIBLE_TIME_BOUNDS", width: '90px', align: 'right' },
            { field: 'remainingTimeBoundAmends', displayName: "TXT_LBL_TIME_BOUNDS_AMEND", width: '90px', align: 'right' },
        ],
        noCommandColumn: true
    };

    $scope.compensationCourses = [];

    $scope.$on('selectedCompensationChanged', function (e, data) {
        if (!!data && !!data.semesterID && !!data.compensation) {
            $scope.compensationCourses = compensationsSvc.getDetailAsync(data.semesterID, data.compensation.studentID);
        } else {
            $scope.compensationCourses.length = 0;
        }
    });
}]);